module.exports = __webpack_public_path__ + "fonts/MiSans-Medium.61729d26.ttf";